import { useGetErpLogin } from './api/useGetErpLogin';

export const useSamlAppLogin = (orgId: number) => {
  const samlAppLoginMutation = useGetErpLogin();

  const onSamlAppLogin = () => {
    samlAppLoginMutation.mutate(
      {
        apiEndpointRequirements: [orgId],
      },
      {
        onSuccess: (response) => {
          const f = document.createElement('form');
          f.setAttribute('method', 'post');
          f.setAttribute('action', response!.acsUrl!);
          f.setAttribute('target', '_blank');

          const i1 = document.createElement('input');
          i1.setAttribute('type', 'hidden');
          i1.setAttribute('name', 'SAMLResponse');
          i1.setAttribute('value', response!.samlResponse!);

          const i2 = document.createElement('input');
          i2.setAttribute('type', 'hidden');
          i2.setAttribute('name', 'RelayState');
          i2.setAttribute('value', response!.relayState!);

          f.appendChild(i1);
          f.appendChild(i2);

          document.getElementsByTagName('body')[0].appendChild(f);
          f.submit();
        },
      },
    );
  };

  return { onSamlAppLogin };
};
